import { render, staticRenderFns } from "./AddVoorziening.vue?vue&type=template&id=03cb236c&"
import script from "./AddVoorziening.vue?vue&type=script&lang=js&"
export * from "./AddVoorziening.vue?vue&type=script&lang=js&"
import style0 from "./AddVoorziening.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports